import React from 'react';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { Mechanism } from './components/sections/Mechanism';
import { Audience } from './components/sections/Audience';
import { OfferFAQ } from './components/sections/OfferFAQ';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="min-h-screen bg-dark text-offwhite font-sans overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Mechanism data-id="element-3" />
      <Audience data-id="element-4" />
      <OfferFAQ data-id="element-5" />
      <Footer data-id="element-6" />
    </div>;
}